export default __webpack_public_path__ + "static/media/career-day.bb6cbe61.svg";